import { createContext } from 'react';
import type { CartDto } from '@/api/cart';

export interface CartContextValue {
  cart: CartDto | null;
  count: number;
  isLoading: boolean;
  add: (itemId: number, qty: number) => Promise<void>;
  setQty: (itemId: number, qty: number) => Promise<void>;
  remove: (itemId: number) => Promise<void>;
  clear: () => Promise<void>;
}

export const CartContext = createContext<CartContextValue | undefined>(undefined);
